import React, { useState, useEffect } from 'react'
import './Booking.css'
import {Container,Row} from 'react-bootstrap'
import {PlanningTable} from '../Planning/PlanningTable'
import {BookingDetail} from './BookingDetail'

export const Booking = ({global}) => {
        const [itemId, setItemId] = useState(0)

        const onSelect = (itemId) => {
                setItemId(itemId)
                //      alert("Booking  "+itemId)
        }

        useEffect(() => {
                //alert('useEffect '+itemId)
        }, [itemId])    


return (

<>
                
{ global.connected() ?
        <Container>
                <Row>
                <PlanningTable global={global} onSelect={onSelect}/>
                </Row>  

                <Row>
                        
                        <BookingDetail PlanningId={itemId} />
                        
                </Row>                      
        </Container>
: <h5>Invalid session?</h5> }

</>
        )
}
